/** Display gross minus discount; empty when gross is unset. */
export const displayNetAmount = (gross, discount) => {
  if (gross === "" || gross == null || gross === undefined) return "";
  const g = Number(gross);
  if (Number.isNaN(g)) return "";
  const d = discount === "" || discount == null || discount === undefined ? 0 : Number(discount);
  if (Number.isNaN(d)) return "";
  return g - d;
};

export const validateNonNegativeMoney = (value, fieldLabel, { required = false } = {}) => {
  if (value === "" || value == null || value === undefined) {
    if (required) return `${fieldLabel} is required.`;
    return null;
  }
  const n = Number(value);
  if (Number.isNaN(n)) return `${fieldLabel} must be a valid number.`;
  if (n < 0) return `${fieldLabel} cannot be negative.`;
  return null;
};

export const validateOfferReceivedFees = (generalInfo) => {
  const topLevel = [
    ["agreedFeePerSemester", "Term fee"],
    ["agreedDiscount", "Discount per term"],
    ["agreedFeePerUnit", "Fee per unit"],
    ["agreedDiscountPerUnit", "Discount per unit"],
  ];
  for (const [key, label] of topLevel) {
    const err = validateNonNegativeMoney(generalInfo?.[key], label);
    if (err) return err;
  }

  const schedule = generalInfo?.termSchedule || [];
  for (let i = 0; i < schedule.length; i++) {
    const row = schedule[i];
    const termLabel = `Term ${i + 1}`;
    for (const [key, label] of [
      ["termFee", "term fee"],
      ["materialFee", "material fee"],
      ["discount", "discount"],
      ["paidAmount", "paid amount"],
    ]) {
      const err = validateNonNegativeMoney(row?.[key], `${termLabel} ${label}`);
      if (err) return err;
    }
  }
  return null;
};

export const validatePlacementFees = (generalInfo) => {
  for (const [key, label] of [
    ["agreedFeePerSemester", "Term fee"],
    ["agreedDiscount", "Discount per term"],
  ]) {
    const err = validateNonNegativeMoney(generalInfo?.[key], label);
    if (err) return err;
  }
  return null;
};
